import React from "react";
import HeroSection from "../../components/HomePageComponents/HeroSection";
import AboutSection from "../../components/HomePageComponents/AboutSection";
import WordsFromDirector from "../../components/HomePageComponents/WordsFromDirector";
import CovenantsShowcase from "../../components/HomePageComponents/ShowCasingSection";
import CovanantsSection from "../../components/HomePageComponents/CovenantSection";
import StatsSection from "../../components/HomePageComponents/StatisticsSection";
import TestimonialsSection from "../../components/HomePageComponents/TestimonialSection";
import FAQSection from "../../components/HomePageComponents/FAQSection";
import RequestCallBack from "../../components/HomePageComponents/RequestCallBack";

const Home = () => (
  <div className="overflow-x-hidden overflow-hidden">
    <HeroSection />
    <div className="lg:px-12 px-2 mt-2 lg:mt-8">
      <AboutSection />
      <WordsFromDirector />
      <CovenantsShowcase />
      <CovanantsSection />
    </div>
    <StatsSection />
    <RequestCallBack />
    <TestimonialsSection />
    <div className="lg:px-12 px-8 mt-8">
      <FAQSection />
    </div>
  </div>
);

export default Home;